import posthog from 'posthog-js';

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(process.env.STUUT_POSTHOG, {
      api_host: 'https://us.i.posthog.com',
      autotrack: {
        dom_event_allowlist: ['click', 'submit'],
        element_allowlist: ['a', 'button', 'input'],
      },
    });
  },
};
